export const BUTTON = {
    SIZE: {
        SMALL: 'small',
        MEDIUM: 'medium',
        LARGE: 'large',
    },
    VARIANT: {
        TOGGLE: 'toggle',
    },
};

export const GA_MEASUREMENT_ID = 'G-CV05Q4D3D5';
